import React from 'react';

import {
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonMenu,
  IonMenuButton,
  IonMenuToggle,
  IonToolbar,
} from '@ionic/react';
import {
  barChartOutline,
  documentTextOutline,
  homeOutline,
  settingsOutline,
} from 'ionicons/icons';

import { DASHBOARD, FINANCE, PERFORMANCE, SETTINGS } from 'consts';
import { useLocation } from 'react-router-dom';

import { useIsImpersonateAllowed } from 'auth/User';
import Impersonate from 'components/Impersonate';
import Typography from 'components/Typography';

import ItemImpersonate from './ItemImpersonate';
import Logo from './Logo';
import './index.css';

const Menu = () => {
  const location = useLocation();

  const isImpersonateAllowed = useIsImpersonateAllowed();

  const getColor = (path: string) => {
    return location.pathname === '/' + path ? 'primary' : 'dark';
  };

  const getIconColor = (path: string) => {
    return location.pathname === '/' + path ? 'primary' : 'medium';
  };

  return (
    <IonMenu contentId={'main-content'} swipeGesture={false}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonMenuButton data-cy={'MenuButton'} color={'medium-shade'} />
          </IonButtons>
          <div className={'toolbar-inner'}>
            <Impersonate />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent force-overscroll={false}>
        <Logo />
        <IonMenuToggle>
          <IonList className={'ion-padding-vertical'}>
            <IonItem
              routerLink={`/${DASHBOARD}`}
              button={true}
              detail={false}
              routerDirection={'root'}
            >
              <IonIcon
                color={getIconColor(DASHBOARD)}
                icon={homeOutline}
                slot={'start'}
              />
              <Typography variant={'subtitle1'} color={getColor(DASHBOARD)}>
                Dashboard
              </Typography>
            </IonItem>
            <IonItem
              routerLink={`/${PERFORMANCE}`}
              button={true}
              detail={false}
              routerDirection={'root'}
            >
              <IonIcon
                color={getIconColor(PERFORMANCE)}
                icon={barChartOutline}
                slot={'start'}
              />
              <Typography variant={'subtitle1'} color={getColor(PERFORMANCE)}>
                Performance
              </Typography>
            </IonItem>
            <IonItem
              routerLink={`/${FINANCE}`}
              detail={false}
              routerDirection={'root'}
            >
              <IonIcon
                color={getIconColor(FINANCE)}
                icon={documentTextOutline}
                slot={'start'}
              />
              <Typography variant={'subtitle1'} color={getColor(FINANCE)}>
                Finance
              </Typography>
            </IonItem>
            <IonItem
              routerLink={`/${SETTINGS}`}
              button={true}
              detail={false}
              routerDirection={'root'}
            >
              <IonIcon
                color={getIconColor(SETTINGS)}
                icon={settingsOutline}
                slot={'start'}
              />
              <Typography variant={'subtitle1'} color={getColor(SETTINGS)}>
                Settings
              </Typography>
            </IonItem>
          </IonList>
        </IonMenuToggle>
      </IonContent>
      <IonFooter>{isImpersonateAllowed ? <ItemImpersonate /> : null}</IonFooter>
    </IonMenu>
  );
};
export default Menu;
